import React from "react";
import styled from "styled-components";

const PROPERTY_ID = "685a5be7242a8d190f6e69e4"; // Tawk.to property
const WIDGET_ID = "1iugfe0gs"; // Tawk.to widget

const SupportChatPage = () => {
  const directChatUrl = `https://tawk.to/chat/${PROPERTY_ID}/${WIDGET_ID}`;

  return (
    <PageWrapper>
      <ChatFrame
        title="Bill Sarthi Live Support Chat"
        src={directChatUrl}
        allow="microphone; camera"
      />
    </PageWrapper>
  );
};

export default SupportChatPage;

// ===== Styled Components =====

const PageWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 64px);
  /* 
    agar aapke top header ki height alag hai to 64px ko adjust kar lena,
    ya sirf height: 100%; bhi rakh sakte ho agar layout flex:1 use karta hai.
  */
  padding: 0;
  margin: 0;
  background: #000; /* loading ke time black background */
`;

const ChatFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;
